import Alpine from 'alpinejs';
document.addEventListener("alpine:init", () => {
    Alpine.data('flowEditor', (current_ig_account_id, flow_id) => ({
        flow_id: flow_id,
        currentIgAccountId: current_ig_account_id,
        state: 'editor',
        isSaved: true,
        isSaving: false,
        isFlowActive: false,
        isEditingName: false,
        flow_name: '',
        reply_comment: '',
        keyword_matching: 'exact',
        flow_trigger_type: 'comment',
        keywords: [{id: null, keyword: ''}],
        steps: [],
        branches: [],
        stepEditorOpen: false,
        currentStep: { id: null, next_step_id: null, state: null, step_type: 'message', content: '', quick_replies: [], delay_seconds: 0, automation_branch_id: null },
        editingBranchIndex: null,
        previous_step_id: null,
        flowDialog: { open: false, message: '', action: null },
    
        init() {
            this.flow_name = document.getElementById('flow_name').value;
            this.reply_comment = document.getElementById('reply_comment').value;
    
            this.steps = this.steps || [];
            this.branches = this.branches || [];
            this.setDefaultState();
    
            //prevent 'backspace' key from navigating back
            document.addEventListener('keydown', function(e) {
                if(e.key === 'Backspace' && e.target === document.body) {
                    e.preventDefault();
                }
            });

            setTimeout(()=>{
                let screenWidth = window.innerWidth;
                //if screenWidth is less than width of #flow-editor, scroll #flow-editor horizontally until its contents are centered
                if(screenWidth < document.getElementById('flow-editor').offsetWidth) {
                    let flowEditorParent = document.getElementById('flow-editor').parentElement;
                    flowEditorParent.scrollLeft = (document.getElementById('flow-editor').offsetWidth - screenWidth)/2;
                }
            }, 1000);
        },
    
        // Load automation flow data
        loadFlow(data) {    
            this.flow_id = data.id;
            this.flow_name = data.name;
            this.reply_comment = data.reply_comment;
            this.isFlowActive = data.active;
            this.flow_trigger_type = data.trigger_type;
            this.keyword_matching = data.keyword_matching; 
            
            console.log('data:', data);
    
            // Reset steps and branches
            this.steps = [];
            this.branches = [];
            this.keywords = [];
            
            // Group branches by automation_step_id
            const quickReplyMap = new Map();
        
            // Map existing branches
            if (data.automation_branches) {
                data.automation_branches.forEach(branch => {
                    if (!quickReplyMap.has(branch.automation_step_id)) {
                        quickReplyMap.set(branch.automation_step_id, []);
                    }
                    quickReplyMap.get(branch.automation_step_id).push({
                        id: branch.quick_reply_id,
                        condition: branch.condition
                    });
                });
                
                this.branches = data.automation_branches.map(branch => ({
                    id: branch.id,
                    automation_step_id: branch.automation_step_id,
                    condition: branch.condition,
                    quick_reply_id: branch.quick_reply_id,
                    next_step_id: branch.next_step_id,
                    state: this.generateRandomStateId()
                }));
            }
        
            // Map existing steps
            if (data.automation_steps) {
                console.log('data.automation_steps:', data.automation_steps);
                //reorder the steps by order
                data.automation_steps.sort((a, b) => a.order - b.order);
    
                this.steps = data.automation_steps.map(step => ({
                    id: step.id,
                    step_type: step.step_type,
                    content: step.content,
                    order: step.order,
                    next_step_id: step.next_step_id,        
                    quick_replies: step.step_type === "question" ? (quickReplyMap.get(step.id) || []) : [],
                    automation_branch_id: step.automation_branch_id || null,
                    delay_seconds: step.delay_seconds,
                    state: this.generateRandomStateId()
                }));

                console.log('steps:', this.steps);
            }else{
                console.log('no steps found');
            }
    
            if (data.automation_keywords) {
                console.log('data.automation_keywords:', data.automation_keywords);
                this.keywords = data.automation_keywords.map(keyword => ({
                    id: keyword.id,
                    keyword: keyword.keyword
                }));
            }
        
            this.$nextTick(() => {
                this.steps = [...this.steps]; // ✅ Force Alpine to detect reactivity
                this.branches = [...this.branches]; // ✅ Force Alpine to detect reactivity
                this.keywords = [...this.keywords]; // ✅ Force Alpine to detect reactivity
                this.setDefaultState();
                setTimeout(()=>{
                    this.adjustBranchMergeLinesInAllShadowRoots();
                    setTimeout(()=>{
                        this.adjustBranchMergeLinesInAllShadowRoots();
                    },100);
                },100);
            });
        },    
    
        setDefaultState() {
            if (this.flow_trigger_type === 'comment') {
                if( this.flow_name != '' && this.reply_comment != '' && this.keywords != ['']) {
                    this.state = 'editor';
                } else {
                    this.state = 'settings';
                }
            } else if (this.flow_trigger_type === 'message') {
                if( this.flow_name != '' && this.keywords != ['']) {
                    this.state = 'editor';
                } else {
                    this.state = 'settings';
                }
            }
        },
    
        canViewEditor() {
            if (this.flow_trigger_type === 'comment') {
                if( this.flow_name != '' && this.reply_comment != '' && this.keywords.length && this.keywords[0]['keyword'] != '') {
                    return true;
                } else {
                    return false;
                }
            } else if (this.flow_trigger_type === 'message') {
                if( this.flow_name != '' && this.keywords.length && this.keywords[0]['keyword'] != '') {
                    console.log('keywords:', this.keywords);
                    return true;
                } else {
                    return false;
                }
            } else if (this.flow_trigger_type === 'story_reply') {
                if( this.flow_name != '' && this.keywords.length && this.keywords[0]['keyword'] != '') {
                    return true;
                } else {
                    return false;
                }
             }else if (this.flow_trigger_type === 'story_mention') {
                return true; 
            }
        },
    
        openFlowDialog(message, action, index) {
            this.flowDialog.open = true;
            this.flowDialog.message = message;
    
            if (action === 'deleteQuickReply') {
                this.flowDialog.action = () => {
                    this.currentStep.quick_replies.splice(index, 1); 
                };
                this.flowDialog.accept_text = 'Delete reply';
            }
    
            if (action === 'deleteStep') {
                this.flowDialog.action = () => {
                    this.deleteStep(this.currentStep.id)
                };
                this.flowDialog.accept_text = 'Delete step';
            }
        },
    
        performFlowDialogAction() {
            this.flowDialog.open = false;
            if (this.flowDialog.action) {
                this.flowDialog.action();
            }
        },
    
        openStepEditor(step = null, branchIndex = null, previous_step_id = null, event = null) {
            this.currentStep = step 
                ? Alpine.reactive({ ...step }) 
                : { id: null, next_step_id: null, state: null, step_type: 'message', content: '', quick_replies: [], automation_branch_id: branchIndex };
    
            this.editingBranchIndex = branchIndex;
            this.stepEditorOpen = true;
            this.previous_step_id = previous_step_id;
    
            this.$nextTick(() => {
                document.querySelector('#current-step-content').focus();
             });
            
            // Ensure event exists (if triggered by a user click)
            if (event) {
                const triggerElement = event.currentTarget; // The clicked button/element
                const editorElement = document.querySelector('.form-step-editor-window-wrapper');
                const parentRect = editorElement.parentElement.getBoundingClientRect(); // Parent container
                //get screen width
                const screenWidth = window.innerWidth;
        
                if (triggerElement && editorElement) {
                    // Get trigger element dimensions and position
                    const rect = triggerElement.getBoundingClientRect();
        
                    // Calculate center position
                    const centerX = rect.left + rect.width / 2;
                    //get the distance from top of page 
                    const centerY = rect.top + window.scrollY + rect.height;
                    const editorElementWidth = editorElement.offsetWidth;
        
                    // Apply absolute positioning
                    editorElement.style.position = 'absolute';
                    editorElement.style.left = `${centerX}px`;
                    editorElement.style.top = `${centerY}px`;
                    editorElement.style.transform = 'translateX(-50%)'; // Center it horizontally
                    // Compute the difference in percentage relative to the parent width
                    //if the editor is too close to the left side of the screen, move it to the right

                    //if screen is wider than 768px
                    if(screenWidth > 768) {
                        if(centerX < 256) {
                            editorElement.style.left = `32px`;
                            editorElement.style.right = `unset`;
                            editorElement.style.transform = 'translateX(0)';
                            //set the left position of the .form-step-editor-window::before and ::after
                        }else if( window.innerWidth - centerX < 256) {
                            editorElement.style.left = `unset`;
                            editorElement.style.right = `32px`;
                            editorElement.style.transform = 'translateX(0)';
                        }
                    } else if(screenWidth > 544) { 
                        editorElement.style.left = `16px`;
                        editorElement.style.right = `16px`;
                        editorElement.style.transform = 'translateX(0)';
                    }else {
                        editorElement.style.left = `0`;
                        editorElement.style.right = `0`;
                        editorElement.style.transform = 'translateX(0)';
                    }
    
                    setTimeout(()=>{
                        const leftDifferencePx =  centerX - editorElement.getBoundingClientRect().left; // Distance from parent left
                        const leftDifferencePercent = (leftDifferencePx / editorElement.getBoundingClientRect().width) * 100;
                        if(centerX < 256) {
                            document.querySelector('.form-step-editor-window').style.setProperty('--editor-window-arrow-left', leftDifferencePercent + "%");
                        }else if( window.innerWidth - centerX < 256) {
                            document.querySelector('.form-step-editor-window').style.setProperty('--editor-window-arrow-left', 'calc('+ leftDifferencePercent + "%)");
                        }else{
                            document.querySelector('.form-step-editor-window').style.setProperty('--editor-window-arrow-left', '50%');
                        }
                    },100);
                }
            }
        },
    
        closeStepEditor() {
            this.flowDialog.open = false;
            this.editingBranchIndex = null;
            this.stepEditorOpen = false;
            this.previous_step_id = null;
        },
    
        stepEditorSaveButtonText() {
            return this.currentStep.id ? 'Save step' : 'Add step';
        },
    
        addQuickReply() {
            this.currentStep.quick_replies.push({ id: Date.now(), condition: '' });
        },
    
        removeQuickReply(index) {
            this.currentStep.quick_replies.splice(index, 1);
        },
    
        generateRandomStateId() {
            return Math.floor(Math.random() * 1000000);
        },
    
        generateUniqueId() {
            return Math.random().toString(36).substr(2, 9);
        },
    
        canSaveStep() {
            if (this.currentStep.step_type === 'message') {
                return this.currentStep.content.trim();
            }
    
            if (this.currentStep.step_type === 'question') {
                return this.currentStep.content.trim() && this.currentStep.quick_replies.length > 0 && this.currentStep.quick_replies.every(reply => reply.condition != '');
            }
        },
    
        saveStep() {
            console.log('save step!');
            if (!this.currentStep.content.trim()) {
                alert('Content cannot be empty.');
                return;
            }
    
            this.currentStep.state = this.generateRandomStateId();
        
            if (this.currentStep.id) {
                if( this.currentStep.step_type === 'message') {
                    this.currentStep.quick_replies = [];
                }
                const index = this.steps.findIndex(s => s.id === this.currentStep.id);
                if (index !== -1) {
                    this.steps[index] = { ...this.currentStep };
                    this.$nextTick(() => {
                        this.steps = [...this.steps]; // ✅ Force Alpine to detect reactivity
                    });
                }
    
                this.syncBranches(this.currentStep.id, this.currentStep.quick_replies);
            } else {
                // Ensure no circular reference
                const existingStep = this.steps.find(s => s.id === this.currentStep.id);
                if (!existingStep) {
                    //randomly generate an id for the new step
                    this.currentStep.id = this.generateUniqueId();
                    while (this.steps.some(s => s.id === this.currentStep.id)) {
                        this.currentStep.id = this.generateUniqueId();
                    }
                    //if this.previous_step_id is not null, we must insert the new step after the previous_step_id in the array
                    if (this.previous_step_id) {
                        const index = this.steps.findIndex(s => s.id === this.previous_step_id);
                        this.steps.splice(index + 1, 0, { ...this.currentStep });
                    } else {
                        this.steps.push({ ...this.currentStep });
                    }
                }
        
                if (this.currentStep.step_type === 'question') {
                    this.currentStep.quick_replies.forEach(reply => {
                        if (!this.branches.some(b => b.automation_step_id === this.currentStep.id && b.quick_reply_id === reply.id)) {
                            let thisBranchId = this.generateUniqueId();
                            while (this.branches.some(b => b.id === thisBranchId)) {
                                thisBranchId = this.generateUniqueId();
                            }
    
                            this.branches.push({
                                id: thisBranchId,
                                automation_step_id: this.currentStep.id,
                                condition: reply.condition,
                                quick_reply_id: reply.id,
                                next_step_id: null,
                                state: this.generateRandomStateId(),
                            });
    
                            //find the quick reply in the current step and update the automation_branch_id
                            const index = this.currentStep.quick_replies.findIndex(r => r.id === reply.id);
                            if (index !== -1) {
                                this.currentStep.quick_replies[index].automation_branch_id = thisBranchId;
                            }
                        }
                    });
                }
        
                if (this.editingBranchIndex !== null && this.branches[this.editingBranchIndex]) {
                    this.branches[this.editingBranchIndex].next_step_id = this.currentStep.id;
                }
            }
        
            this.editingBranchIndex = null;
            this.$nextTick(() => {
                this.steps = [...this.steps]; // ✅ Force Alpine to detect reactivity
                this.adjustBranchMergeLinesInAllShadowRoots();
            });
            this.isSaved = false;
            this.closeStepEditor();
            this.updateStepsNextStepIds();
        },
    
        deleteStep(stepId) {
            this.steps = this.steps.filter(s => s.id !== stepId);
            this.branches = this.branches.filter(b => b.automation_step_id !== stepId);
            this.isSaved = false;
            this.adjustBranchMergeLinesInAllShadowRoots();
            this.closeStepEditor();
            this.updateStepsNextStepIds();
        },
    
        updateStepsNextStepIds() { 
            console.log('updating next step ids');
            console.log('steps:', this.steps);

            this.steps.forEach(step => {
                //check if the step has a automation_branch_id, and if so, find it's next_step_id by looking at the steps in the branch
                if (step.automation_branch_id) {
                    const branch = this.branches.find(b => b.id === step.automation_branch_id);
                    console.log('branch:', branch);
                    if (branch) {
                        //find the step's position in the array
                        const index = this.steps.findIndex(s => s.id === step.id);
                        //find the step with the next highest index that has the same automation_branch_id and set that to be the next_step_id for this step
                        let nextStep = this.steps.slice(index + 1).find(s => s.automation_branch_id === step.automation_branch_id);
    
                        if (nextStep) {
                            step.next_step_id = nextStep.id;
                        } else {
                            if (branch.automation_step_id) {
                                const branchParentStep = this.steps.find(s => s.id === branch.automation_step_id);  
                                if (branchParentStep) {
                                    step.next_step_id = branchParentStep.next_step_id || null;
                                    branch.next_step_id = branchParentStep.next_step_id || null;
                                } else {
                                    step.next_step_id = null;
                                }
                            } else {
                                step.next_step_id = null;
                            }
                        }
                    }
                } else {
                    // Linear step (not part of a branch)
                    const index = this.steps.findIndex(s => s.id === step.id);
                    if (index < this.steps.length - 1) {
                        const nextStep = this.steps.slice(index + 1).find(s => !s.automation_branch_id);
                        step.next_step_id = nextStep ? nextStep.id : null;
                    } else {
                        step.next_step_id = null;
                    }
                }
                
            });
        },
     
        syncBranches(stepId, quickReplies) {
            // Remove branches that no longer have a matching quick reply
            this.branches = this.branches.filter(branch => 
                branch.automation_step_id !== stepId || quickReplies.some(reply => reply.id === branch.quick_reply_id)
            );
    
            this.branches.forEach(branch => {
                branch.state = this.generateRandomStateId();
                //find quick reply by id and update the condition
                const quickReply = quickReplies.find(reply => reply.id === branch.quick_reply_id);
                if (quickReply) {
                    branch.condition = quickReply.condition;
                }
            });
        
            // Add new branches for any new quick replies
            quickReplies.forEach(reply => {
                const existingBranch = this.branches.find(branch => branch.automation_step_id === stepId && branch.quick_reply_id === reply.id);
                if (!existingBranch) {
                    let thisBranchId = this.generateUniqueId();
                    while (this.branches.some(b => b.id === thisBranchId)) {
                        thisBranchId = this.generateUniqueId();
                    }
    
                    this.branches.push({
                        id: thisBranchId,
                        automation_step_id: stepId,
                        condition: reply.condition,
                        quick_reply_id: reply.id,
                        next_step_id: null,
                        state: this.generateRandomStateId(),
                    });
    
                    //add the automation_branch_id to the quick reply
                    const index = quickReplies.findIndex(r => r.id === reply.id);
                    if (index !== -1) {
                        quickReplies[index].automation_branch_id = thisBranchId;
                    }
                }
            });
    
    
            this.$nextTick(() => {
                this.steps = [...this.steps]; // ✅ Force Alpine to detect reactivity
                this.branches = [...this.branches]; // ✅ Force Alpine to detect reactivity
            });
        },    
    
        adjustBranchMergeLines(thisDocument) {
            thisDocument.querySelectorAll('.quick-reply-branches__inner').forEach(branchesInner => {
                const branches = [...branchesInner.querySelectorAll('.quick-reply-branch')];
                
                if (branches.length < 2) return; // Ensure at least two branches exist
    
                // Get the last `.line` elements from the first and last branches
                const firstBranchLines = branches[0].querySelector('.quick-reply-branch__vertical').querySelectorAll('.line');
                const lastBranchLines = branches[branches.length - 1].querySelector('.quick-reply-branch__vertical').querySelectorAll('.line');
        
                if (!firstBranchLines.length || !lastBranchLines.length) return; // Ensure lines exist
        
                const firstLine = firstBranchLines[firstBranchLines.length - 1];
                const lastLine = lastBranchLines[lastBranchLines.length - 1];
        
                const firstLineRect = firstLine.getBoundingClientRect();
                const lastLineRect = lastLine.getBoundingClientRect();
                const branchesInnerRect = branchesInner.getBoundingClientRect();
        
                // Calculate width based on first and last line positions
                const startX = firstLineRect.left - branchesInnerRect.left;
                const endX = lastLineRect.left - branchesInnerRect.left;
                const width = endX - startX + 3;
        
                // Locate the corresponding .branch-merge-line--horizontal
                const mergeLine = branchesInner.parentElement.querySelector('.branch-merge-line--horizontal');
    
                if (mergeLine) {
                    mergeLine.style.width = `${width}px`;
                    mergeLine.style.marginLeft = `${startX}px`;
                }
            });
        },
    
        findShadowRoots(node = document) {
            const shadowRoots = [];
            
            function traverse(node) {
                if (node.shadowRoot) {
                    shadowRoots.push(node.shadowRoot);
                    traverse(node.shadowRoot); 
                }
                node.childNodes.forEach(child => traverse(child));
            }
            
            traverse(node);
            return shadowRoots;
        },
    
        adjustBranchMergeLinesInAllShadowRoots() {
            const shadowRoots = this.findShadowRoots();
            shadowRoots.forEach(shadowRoot => this.adjustBranchMergeLines(shadowRoot));
            this.adjustBranchMergeLines(document); // Also run on main document
        },
    
        saveFlow() {
            this.isSaving = true;
            const stepIdMap = {}; // To track old-to-new ID mappings
        
            // Assign order based on position in the steps array
            this.steps.forEach((step, index) => {
                step.order = index + 1; // Ensure order starts from 1
                if (!step.next_step_id || step.next_step_id === "0" || step.next_step_id === 0) {
                    step.next_step_id = null;
                }
            });
        
            // Prepare payload for Rails
            const payload = {
                automation_flow: {
                    name: this.flow_name,
                    reply_comment: this.reply_comment,
                    active: this.isFlowActive,
                    trigger_type: this.flow_trigger_type,
                    keyword_matching: this.keyword_matching,
                    automation_steps_attributes: this.steps.map(step => ({
                        id: typeof step.id === "string" && step.id.startsWith("temp_") ? null : step.id,
                        step_type: step.step_type,
                        content: step.content,
                        order: step.order,
                        next_step_id: step.next_step_id ? stepIdMap[step.next_step_id] || step.next_step_id : null,
                        automation_flow_id: this.flow_id, // Ensure correct association
                        automation_branch_id: step.automation_branch_id,
                        delay_seconds: step.delay_seconds || 0
                    })),
                    automation_branches_attributes: this.branches.map(branch => ({
                        id: typeof branch.id === "string" && branch.id.startsWith("temp_") ? null : branch.id,
                        automation_step_id: stepIdMap[branch.automation_step_id] || branch.automation_step_id,
                        condition: branch.condition,
                        next_step_id: branch.next_step_id ? stepIdMap[branch.next_step_id] || branch.next_step_id : null,
                        quick_reply_id: branch.quick_reply_id,
                        automation_flow_id: this.flow_id 
                    })),
                    automation_keywords_attributes: this.keywords.map(keyword => {
                        return keyword.id ? { id: keyword.id, keyword: keyword.keyword, automation_flow_id: this.flow_id } : { keyword: keyword.keyword, automation_flow_id: this.flow_id }
                    })
                }
            };
    
        
            // Send to Rails backend via AJAX or fetch
            fetch(this.flow_id ? `/automation_flows/${this.flow_id}` : "/automation_flows", {
                method: this.flow_id ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                this.isSaving = false;
                if (!data.id) {
                    throw new Error("Save failed: " + JSON.stringify(data.error));
                }
    
                if (!this.flow_id) {
                    this.flow_id = data.id; // Set flow_id from Rails response
                }
                
                this.isSaved = true; // Mark as saved
                return fetch(`/automation_flows/${this.flow_id}.json`);
            })
            .then(response => response.json())
            .then(updatedFlow => {
                console.log("Updated Flow from DB:", updatedFlow);
                this.loadFlow(updatedFlow); // Reload the editor with fresh data from DB
            })
            .catch(error => console.error("Error saving or loading flow:", error));
        }, 
        
        saveButtonText() {
            if (this.isSaving) {
                return 'Saving...'
            } else if (this.isSaved) {
                return 'Saved';
            } else {
                return 'Save changes';
            }
        },

        delayInWords(delay_seconds) {
            if (delay_seconds < 60) {
                return `${delay_seconds} seconds`;
            } else if (delay_seconds < 3600) {
                return `${Math.floor(delay_seconds / 60)} minutes`;
            } else {
                return `${Math.floor(delay_seconds / 3600)} hours`;
            }
        }
    }));
    
});